import { useContext } from "react";
import {
  BannerButton,
  BannerButtonVariant,
  BannerType,
  InformationBannerContext,
} from "../Providers/InformationBarProvider";

const InformationBanner = () => {
  const { bannerData, isShown, showBanner } = useContext(
    InformationBannerContext
  );

  const dismiss = () => {
    showBanner(false);
  };

  return (
    <>
      {isShown && bannerData?.type ? (
        <>
          {bannerData.type === BannerType.ACTION ? (
            <div
              id="informational-banner"
              className="fixed top-20 left-0 z-50 flex flex-col justify-between w-full p-4 border-b border-neutral md:flex-row bg-gray-50"
            >
              <div className="mb-4 md:mb-0 md:mr-4">
                <h2 className="mb-1 text-base font-semibold text-gray-900 dark:text-white">
                  {bannerData?.data.title}
                </h2>
                <p className="flex items-center text-sm font-normal text-gray-500 dark:text-gray-400">
                  {bannerData?.data.description}
                </p>
              </div>
              <div className="flex items-center flex-shrink-0">
                {bannerData.data?.onLearnButton
                  ? RenderButton(bannerData.data.onLearnButton)
                  : null}

                {bannerData?.data?.onActionButton
                  ? RenderButton(bannerData.data.onActionButton)
                  : null}
                <button
                  data-dismiss-target="#informational-banner"
                  type="button"
                  className="flex-shrink-0 inline-flex justify-center w-7 h-7 items-center text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 dark:hover:bg-gray-600 dark:hover:text-white"
                  onClick={dismiss}
                >
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only">Close banner</span>
                </button>
              </div>
            </div>
          ) : null}

          {bannerData.type === BannerType.INFO ? (
            <div
              id="informational-banner"
              className="fixed top-20 left-0 z-50 flex flex-col justify-between w-full p-4 border-b border-gray-200 md:flex-row bg-gray-50 dark:bg-gray-700 dark:border-gray-600"
            >
              <div className="mb-4 md:mb-0 md:mr-4">
                <h2 className="mb-1 text-base font-semibold text-gray-900 dark:text-white">
                  {bannerData?.data.title}
                </h2>
                <p className="flex items-center text-sm font-normal text-gray-500 dark:text-gray-400">
                  {bannerData?.data.description}
                </p>
              </div>
              <div className="flex items-center flex-shrink-0">
                <button
                  data-dismiss-target="#informational-banner"
                  type="button"
                  className="flex-shrink-0 inline-flex justify-center w-7 h-7 items-center text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 dark:hover:bg-gray-600 dark:hover:text-white"
                  onClick={dismiss}
                >
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only">Close banner</span>
                </button>
              </div>
            </div>
          ) : null}

          {bannerData.type === BannerType.ERROR ? (
            <div
              id="error-banner"
              className="fixed top-20 left-0 z-50 flex flex-col justify-between w-full p-4 border-b border-accent md:flex-row bg-error"
            >
              <div className="mb-4 md:mb-0 md:mr-4">
                <h2 className="mb-1 text-base font-semibold text-neutral">
                  Error: {bannerData?.data.title}
                </h2>
                <p className="flex items-center text-sm font-normal text-neutral">
                  {bannerData?.data.description}
                </p>
              </div>
              <div className="flex items-center flex-shrink-0">
                <button
                  data-dismiss-target="#error-banner"
                  type="button"
                  className="flex-shrink-0 inline-flex justify-center w-7 h-7 items-center text-neutral hover:bg-accent hover:text-neutral rounded-lg text-sm p-1.5"
                  onClick={dismiss}
                >
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only">Close banner</span>
                </button>
              </div>
            </div>
          ) : null}
        </>
      ) : null}
    </>
  );
};

const RenderButton = (props: BannerButton) => {
  switch (props.variant) {
    case BannerButtonVariant.OUTLINE:
      return (
        <div
          onClick={props.onClick}
          className="hover:cursor-pointer inline-flex items-center justify-center px-3 py-2 mr-3 text-xs font-medium text-gray-900 bg-white border border-gray-200 rounded-lg focus:outline-none hover:bg-gray-100 hover:text-secondary focus:z-10 focus:ring-4 focus:ring-gray-200"
        >
          {props.icon ? props.icon : null}
          {props.title}
        </div>
      );
    case BannerButtonVariant.PRIMARY:
      return (
        <div
          onClick={props.onClick}
          className="inline-flex hover:cursor-pointer items-center justify-center px-3 py-2 mr-2 text-xs font-medium text-white bg-primary rounded-lg hover:bg-secondary focus:outline-none"
        >
          {props.title}
          {props.icon ? props.icon : null}
        </div>
      );

    default:
      return <></>;
  }
};

export default InformationBanner;
